/**
 * @generated SignedSource<<67d2bbd7d59b1ab8335ec1f2e3d8b5b0>>
 * @relayHash ca6bf320095164b2c7bf8c7a0da7ff96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 545cafff76808c8fbdaa985de5b3004568e314aaecfce1af44e865ce4984f817

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpObjectStoreArticleContentType = "FOLDER" | "PAGE" | "%future added value";
export type HelpObjectStoreArticleSearchExpandType = "ANCESTORS" | "VIEW_COUNT" | "%future added value";
export type HelpObjectStoreSupportSiteArticleSearchInput = {
  articleIds?: ReadonlyArray<string> | null;
  contentTypes?: ReadonlyArray<HelpObjectStoreArticleContentType> | null;
  expand?: ReadonlyArray<HelpObjectStoreArticleSearchExpandType> | null;
  orderBy?: string | null;
  parentId?: AGG$Long | null;
  query?: string | null;
  topLevelArticlesOnly?: boolean | null;
};
export type csmFolderSearchArticlesForSupportSiteQuery$variables = {
  cloudId: string;
  first?: number | null;
  helpCenterAri: string;
  input?: HelpObjectStoreSupportSiteArticleSearchInput | null;
};
export type csmFolderSearchArticlesForSupportSiteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"mainCsmFolderItemsRenderer_data">;
};
export type csmFolderSearchArticlesForSupportSiteQuery = {
  response: csmFolderSearchArticlesForSupportSiteQuery$data;
  variables: csmFolderSearchArticlesForSupportSiteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "mainCsmFolderItemsRenderer_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [
          {
            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "contentType"
                      },
                      {
                        "concreteType": "HelpObjectStoreArticleRelative",
                        "kind": "LinkedField",
                        "name": "ancestors",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpObjectStoreArticleURLInfo",
                        "kind": "LinkedField",
                        "name": "urlInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "shareUrl"
                          }
                        ]
                      }
                    ],
                    "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "filters": [
          "helpCenterAri",
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "CsmFolderItemsRenderer__helpObjectStore_searchArticlesForSupportSite",
        "kind": "LinkedHandle",
        "name": "helpObjectStore_searchArticlesForSupportSite"
      }
    ]
  },
  "params": {
    "id": "545cafff76808c8fbdaa985de5b3004568e314aaecfce1af44e865ce4984f817",
    "metadata": {},
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4e2df91a41eb5d8ce8ae2f48a0e1068e";

export default node;
